<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '@/firebase';
import { useUserStream } from '@/composables/useUserStream';

const { start, stop } = useUserStream();
let unsubscribeAuth = null;

onMounted(() => {
  unsubscribeAuth = onAuthStateChanged(auth, (user) => {
    if (user) {
      start(user.uid);
    } else {
      stop();
    }
  });
});

onUnmounted(() => {
  stop();
  if (unsubscribeAuth) unsubscribeAuth();
});
</script>

<style>
</style>
